import type { BalanceBundle } from '@guildrise/shared';
import { useEffect, useState } from 'react';
import { ApiError, fetchBalance } from '../shared/api.js';

/**
 * Загрузка пакета баланса.
 *
 * Клиент только читает цифры — считает по ним всегда сервер.
 * Пакет кешируется браузером по ETag: тот же хеш не перекачивается.
 */
export type BalanceState =
  | { status: 'loading' }
  | { status: 'error'; message: string }
  | { status: 'ready'; bundle: BalanceBundle };

export function useBalance(enabled: boolean): BalanceState {
  const [state, setState] = useState<BalanceState>({ status: 'loading' });

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;

    fetchBalance()
      .then((bundle) => {
        if (!cancelled) setState({ status: 'ready', bundle });
      })
      .catch((error: unknown) => {
        if (cancelled) return;
        setState({
          status: 'error',
          message: error instanceof ApiError ? error.message : 'Баланс недоступен',
        });
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return state;
}
